"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var helper_toolkit_ts_1 = require("helper-toolkit-ts");
var __1 = require("..");
var LegendContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    justify-content: space-between;\n    flex-direction: row-reverse;\n    padding: .5rem 1rem;\n"], ["\n    display: flex;\n    justify-content: space-between;\n    flex-direction: row-reverse;\n    padding: .5rem 1rem;\n"])));
var LegendItem = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    text-align: center;\n"], ["\n    text-align: center;\n"])));
;
var Legend = function (_a) {
    var maxValues = _a.maxValues;
    var getItems = function () {
        return maxValues.map(function (val, index) {
            return (React.createElement(LegendItem, { key: "legend-item-" + index },
                React.createElement(__1.FireflyIcon, { size: index }),
                React.createElement("div", { className: 'font-size--3' },
                    React.createElement("span", null, helper_toolkit_ts_1.numberFns.abbreviateNumber(val)))));
        });
    };
    return (React.createElement(LegendContainer, null, getItems()));
};
exports.default = Legend;
var templateObject_1, templateObject_2;
